var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "load-more" }, [
    !_vm.isCompleted()
      ? _c(
          "div",
          { staticClass: "btnLoad", on: { click: _vm.loadMore } },
          [
            _vm.isLoading()
              ? _c("a-icon", { attrs: { type: "loading" } })
              : _vm._e(),
            _vm._v(
              "\n        " +
                _vm._s(_vm.isLoading() ? "Loading..." : "Load more") +
                "\n\n        "
            ),
            _c("span", { staticClass: "number" }, [
              _vm._v(
                " ( " +
                  _vm._s(_vm.totalReceived()) +
                  " loaded of " +
                  _vm._s(_vm.history().totalCount) +
                  " messages ) "
              ),
            ]),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "btnLoad completed" },
          [
            _c("a-icon", { attrs: { type: "cloud-sync" } }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.allHistoryLoaded")) +
                "\n        "
            ),
            _c("span", { staticClass: "number" }, [
              _vm._v(" (" + _vm._s(_vm.history().totalCount) + " message )"),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }